
export const common = {
  // Navigation
  home: 'Home',
  plans: 'Plans',
  wallet: 'Wallet',
  rewards: 'Rewards',
  profile: 'Profile',
  
  // Common actions
  subscribe: 'Subscribe',
  claim: 'Claim',
  withdraw: 'Withdraw',
  save: 'Save',
  cancel: 'Cancel',
  close: 'Close',
  continue: 'Continue',
  back: 'Back',
  next: 'Next',
  confirm: 'Confirm',
  
  // Home page
  welcomeBack: 'Welcome back',
  earnRewards: 'Earn rewards by trying delicious meals today!',
  subscribeToStart: 'Subscribe to a plan and start earning rewards!',
  availableMeals: 'Available Meals',
  rewardsLeft: 'rewards left',
  
  // Plans
  chooseYourPlan: 'Choose Your Plan',
  selectPlanToStart: 'Select a plan to start earning rewards',
  yourBalance: 'Your Balance',
  perMonth: 'per month',
  mealsPerDay: 'meals per day',
  perReward: 'per reward',
  mostPopular: 'Most Popular',
  
  // Wallet
  myWallet: 'My Wallet',
  manageBalance: 'Manage your balance and earnings',
  accountBalance: 'Account Balance',
  totalEarnings: 'Total Earnings',
  receive: 'Receive',
  recentTransactions: 'Recent Transactions',
  mealReward: 'Meal Reward',
  noTransactions: 'No transactions yet',
  
  // Rewards
  myRewards: 'My Rewards',
  trackRewards: 'Track your daily rewards and achievements',
  todaysProgress: 'Today\'s Progress',
  rewardsClaimed: 'Rewards Claimed',
  currentPlan: 'Current Plan',
  dailyLimit: 'Daily Limit',
  claimedRewards: 'Claimed Rewards',
  earned: 'Earned',
  noRewardsClaimed: 'No rewards claimed yet',
  startClaiming: 'Start claiming rewards by trying delicious meals!',
  
  // Profile
  manageAccount: 'Manage your account and preferences',
  member: 'Member',
  totalEarned: 'Total Earned',
  accountSettings: 'Account Settings',
  editProfile: 'Edit Profile',
  notifications: 'Notifications',
  privacySecurity: 'Privacy & Security',
  helpSupport: 'Help & Support',
  signOut: 'Sign Out',
  
  // Modals
  subscriptionRequired: 'Subscription Required',
  subscribeToAccess: 'Subscribe to a plan to access meals and start earning rewards',
  viewPlans: 'View Plans',
  
  // Meal details
  mealDetails: 'Meal Details',
  nutritionFacts: 'Nutrition Facts',
  calories: 'Calories',
  protein: 'Protein',
  carbs: 'Carbs',
  fat: 'Fat',
  quantity: 'Quantity',
  portions: 'portions',
  claimReward: 'Claim Reward',
  processing: 'Processing',
  
  // Success messages
  congratulations: 'Congratulations!',
  rewardClaimed: 'Reward Claimed!',
  youEarned: 'You earned',
  fromMeal: 'from meal',
  subscriptionSuccessful: 'Subscription Successful!',
  successfullySubscribed: 'You\'ve successfully subscribed to the',
  planCost: 'Plan Cost',
  remainingBalance: 'Remaining Balance',
  startEarningRewards: 'Start Earning Rewards',
  
  // Withdrawal
  withdrawFunds: 'Withdraw Funds',
  availableForWithdrawal: 'Available for Withdrawal',
  enterAmount: 'Enter amount',
  minimumWithdrawal: 'Minimum withdrawal $10',
  insufficientFunds: 'Insufficient funds',
  withdrawalSuccessful: 'Withdrawal Successful!',
  fundsTransferred: 'Funds have been transferred to your account',
  
  // Profile edit
  editYourProfile: 'Edit Your Profile',
  fullName: 'Full Name',
  emailAddress: 'Email Address',
  phoneNumber: 'Phone Number',
  
  // Sign out confirmation
  signOutConfirmation: 'Sign Out Confirmation',
  sureToSignOut: 'Are you sure you want to sign out of your account?',
  
  // Language
  language: 'Language',
  selectLanguage: 'Select Language',
  spanish: 'Spanish',
  english: 'English',

  // Referral System
  referral: 'Referral',
  referralProgram: 'Referral Program',
  inviteFriends: 'Invite Friends & Earn',
  yourReferralCode: 'Your Referral Code',
  copyCode: 'Copy Code',
  codeCopied: 'Code Copied!',
  shareReferralLink: 'Share Referral Link',
  referralStats: 'Referral Statistics',
  totalReferrals: 'Total Referrals',
  activeAgents: 'Active Agents',
  totalEarnings: 'Total Earnings',
  weeklyBonus: 'Weekly Bonus',
  
  // Reward Tiers
  rewardTiers: 'Reward Tiers',
  guide: 'Guide',
  dulceExpert: 'Dulce Expert',
  premiumAgents: 'Premium Agents',
  grandAgent: 'Grand Agent',
  
  // Tier Descriptions
  guideDesc: 'Earn $100 for every 10 active agents',
  dulceExpertDesc: 'Earn $1,000 for every 90 active agents',
  premiumAgentsDesc: 'Earn $5,000 for every 450 active agents + $100 weekly bonus',
  grandAgentDesc: 'Earn $8,000 for every 1,000 active agents + $250 weekly bonus',
  
  // Actions
  inviteNow: 'Invite Now',
  shareLink: 'Share Link',
  viewDetails: 'View Details',
  
  // Status
  currentTier: 'Current Tier',
  nextTier: 'Next Tier',
  progress: 'Progress',
  agentsNeeded: 'agents needed',
  
  // Referral History
  referralHistory: 'Referral History',
  recentReferrals: 'Recent Referrals',
  joinedOn: 'Joined on',
  active: 'Active',
  inactive: 'Inactive',
  noReferrals: 'No referrals yet',
  startInviting: 'Start inviting friends to earn rewards',
  
  // Share Messages
  shareMessage: 'Join me on this amazing platform and start earning! Use my referral code:',
  
  // Additional referral translations
  referralEarnings: 'Referral Earnings',
  earnUpTo: 'Earn up to',
  perReferralTier: 'per referral tier',
  viewReferralProgram: 'View Referral Program',
  agents: 'agents',
  weekly: 'weekly',
  copyLink: 'Copy Link',
  total: 'Total',

  // Partners section
  ourPartners: 'Our Partners',
  trustedByLeading: 'Trusted by leading marketplaces'
};
